module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 118
// module chunks = 0